/* tslint:disable */
/* eslint-disable */
/**
 * Haltian API-spec
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * General info response object
 * @export
 * @interface CreateDeploymentGroupResponse
 */
export interface CreateDeploymentGroupResponse {
    /**
     * 
     * @type {object}
     * @memberof CreateDeploymentGroupResponse
     */
    data?: object;
}

export function CreateDeploymentGroupResponseFromJSON(json: any): CreateDeploymentGroupResponse {
    return CreateDeploymentGroupResponseFromJSONTyped(json, false);
}

export function CreateDeploymentGroupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDeploymentGroupResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : json['data'],
    };
}

export function CreateDeploymentGroupResponseToJSON(value?: CreateDeploymentGroupResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
    };
}


